import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  doc,
  getDoc,
} from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { getUserPosts, getSavedPosts, getPostLikes } from "../../../pages/auth/utils/firebase/userOperations";

export const fetchSinglePost = createAsyncThunk(
  "posts/fetchSinglePost",
  async (postId, { rejectWithValue }) => {
    try {
      if (!postId) throw new Error("Post ID is required");
      const docRef = doc(db, "posts", postId);
      const docSnap = await getDoc(docRef);
      if (!docSnap.exists()) throw new Error("Post not found");

      const data = docSnap.data();

      // Filter out deleted posts
      if (data.status === "deleted") throw new Error("Post has been deleted");

      const timestamp =
        data.timestamp && typeof data.timestamp.toDate === "function"
          ? data.timestamp.toDate()
          : new Date();

      const avatar = data.userPhotoURL;
      const isValidAvatar =
        avatar &&
        avatar !== "null" &&
        avatar !== "undefined" &&
        typeof avatar === "string" &&
        avatar.trim() !== "";

      return {
        id: docSnap.id,
        userId: data.userId || data.uid || null,
        username: data.username || data.userName || data.displayName || "User",
        userProfession: data.userProfession || data.profession || "",
        content: typeof data.content === "string" ? data.content : "",
        timestamp,
        actionTag: data.actionTag || "describe",
        userPhotoURL: isValidAvatar ? avatar : null,
        title: data.title || "",
        imageUrl: data.imageUrl || "",
        imageUrls: Array.isArray(data.imageUrls) ? data.imageUrls : [],
        link: data.link || "",
        issue: data.issue || null,
        scale: data.scale || "",
        location: data.location || "",
        issueStatus: data.issueStatus || "",
        shares: data.shares || 0,
        commentCount: data.commentCount || 0,
        topLevelCommentCount:
          (data.topLevelCommentCount ?? data.commentCount) || 0,
        likeCount: data.likeCount || 0,
        projectId: data.projectId || null,
        hasProject: !!data.hasProject,
        status: data.status || "active",
        type: data.type || null,
        sharedPostId: data.sharedPostId || null,
        sharedPostData: data.sharedPostData || null,
        linkPreviewData: data.linkPreviewData || null,
        isLinkPost: data.isLinkPost || false,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchUserPosts = createAsyncThunk(
  "posts/fetchUserPosts",
  async (userId, { rejectWithValue }) => {
    try {
      const posts = await getUserPosts(userId);
      return posts;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchSavedPosts = createAsyncThunk(
  "posts/fetchSavedPosts",
  async (_, { rejectWithValue }) => {
    const fetchStartedAt = Date.now();
    try {
      const posts = await getSavedPosts();
      return { posts, fetchStartedAt };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchPostLikes = createAsyncThunk(
  "posts/fetchPostLikes",
  async (postId, { rejectWithValue }) => {
    try {
      const likes = await getPostLikes(postId);
      return { postId, likes };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
